import { Game } from '../gql-types';
import { genericHookContextBuilder } from '../util/genericHookContextBuilder';
import useLocalStorage from '../hooks/useLocalStorage';

const DEFAULT_AVAILABLE_GAME: Game | null | undefined = null;
const DEFAULT_IS_AUTHENTICATED = false;
const DEFAULT_IS_IN_GAME = false;

function useProfile() {
    const [availableGame, setAvailableGame] = useLocalStorage('sifrovka-availableGame', DEFAULT_AVAILABLE_GAME);
    const [isAuthenticated, setAuthenticated] = useLocalStorage('sifrovka-isAuthenticated', DEFAULT_IS_AUTHENTICATED);
    const [isInGame, setInGame] = useLocalStorage('sifrovka-isInGame', DEFAULT_IS_IN_GAME);
    const [token, setToken] = useLocalStorage<string | null>('sifrovka-token', null);

    const clearProfile = () => {
        setAvailableGame(DEFAULT_AVAILABLE_GAME);
        setInGame(DEFAULT_IS_IN_GAME);
        setAuthenticated(DEFAULT_IS_AUTHENTICATED);
        setToken(null);
    };
    const loadAvailableGame = (gameData?: Game | null) => {
        setInGame(true);
        setAvailableGame(gameData);
    };
    const state = {
        availableGame,
        isInGame,
        isAuthenticated,
        token,
    };
    return {
        ...state,
        loadAvailableGame,
        clearProfile,
        setAvailableGame,
        setAuthenticated,
        setToken,
    };
}

export const { ContextProvider: ProfileContextProvider, Context: ProfileContext } =
    genericHookContextBuilder(useProfile);
